var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6565;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,491c-5.7,0-11.1-2.4-14.9-6.6c-6.4-7.1-156.7-175.9-156.7-291.8C84.4,98,161.4,21,256,21 c94.6,0,171.6,77,171.6,171.6c0,115.9-150.3,284.6-156.7,291.8C267.1,488.6,261.7,491,256,491z M256,31 c-89.1,0-161.6,72.5-161.6,161.6c0,45.8,25.8,108.6,74.5,181.5c38.3,57.3,78,101.7,79.7,103.6c1.9,2.1,4.6,3.3,7.4,3.3 c2.9,0,5.5-1.2,7.4-3.3c6.3-7,154.2-173,154.2-285.1C417.6,103.5,345.1,31,256,31z M256,281.4c-49,0-88.8-39.8-88.8-88.8 c0-49,39.8-88.8,88.8-88.8s88.8,39.8,88.8,88.8C344.8,241.6,305,281.4,256,281.4z M256,113.8c-43.5,0-78.8,35.4-78.8,78.8 s35.4,78.8,78.8,78.8s78.8-35.4,78.8-78.8C334.8,149.1,299.5,113.8,256,113.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8afaf31d04d5720fbb170272f54218a9.svg";
export { ForwardRef as ReactComponent };